import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

// Sends the "account created successfully" email once, right after a user
// confirms their email. Guarded by a `welcome_sent` flag in user metadata so
// it can never fire twice, and only fires for users whose email is confirmed.
export const sendWelcomeEmail = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { userId } = context as { userId: string };
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data, error } = await supabaseAdmin.auth.admin.getUserById(userId);
    const user = data?.user;
    if (error || !user || !user.email) return { sent: false };
    if (!user.email_confirmed_at) return { sent: false };
    if (user.user_metadata?.welcome_sent) return { sent: false };

    const firstName = (user.user_metadata?.first_name as string) || "";
    const { sendMails, welcomeEmail } = await import("@/lib/email-smtp.server");

    try {
      await sendMails([
        {
          to: user.email,
          reply: "info@mrpanda.gr",
          subject: "Ο λογαριασμός σου είναι έτοιμος! 🎉 — MrPanda",
          html: welcomeEmail(firstName),
        },
      ]);
    } catch (err) {
      console.error("welcome: send failed", err);
      return { sent: false };
    }

    await supabaseAdmin.auth.admin.updateUserById(userId, {
      user_metadata: { ...user.user_metadata, welcome_sent: true },
    });

    return { sent: true };
  });
